import styled from "styled-components";

export const Container = styled.div`
  background-image: url("./images/backGroud_input.svg");
  align-items: center;
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const SizeContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  max-width: 500px;
  width: 100%;
`;

export const MainContainer = styled.div`
  background-color: #366796;
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-bottom: 30px;
  width: 100%;
  h2 {
    align-items: center;
    display: flex;
    justify-content: center;
    padding: 30px 0;
    width: 100%;
    span {
      color: #2afaa5;
      margin-left: 25px;
    }
  }
`;

export const SubTitle = styled.h2`
  align-items: center;
  background-color: #fa821f;
  box-shadow: 0 6px 5px rgba(0, 0, 0, 0.2);
  color: #fff;
  display: flex;
  font-size: 20px;
  height: 60px;
  justify-content: center;
  margin: 50px auto 0px;
  position: relative;
  width: 100%;
  img {
    border: 7px solid #fa821f;
    border-radius: 50px;
    margin-top: -90px;
    position: absolute;
    width: 70px;
  }
`;

export const NegociationAproved = styled.h2`
  align-items: center;
  background-color: #fa821f;
  box-shadow: 0 6px 5px rgba(0, 0, 0, 0.2);
  color: #fff;
  display: flex;
  font-size: 20px;
  height: 60px;
  justify-content: center;
  position: relative;
  width: 100%;
  cursor: pointer;
  border-top: solid 1px rgba(0, 0, 0, 0.6);
  &:hover {
    opacity: 0.9;
  }
`;

export const RequestContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 25px;
  min-width: 300px;
  margin: 0 auto 100px;
  width: 100%;
`;


export const ContainerCard = styled.div`
  align-items: flex-end;
  border-radius: 50px 25px 0 0;
  background-color: #eb6d03;
  display: flex;
  flex-direction: column;
  margin: 15px auto;
  width: 350px;
`;

export const Header = styled.div`
  align-items: center;
  border-radius: 50px 25px 0 50px;
  box-shadow: 0 2px 5px 2px rgba(0, 0, 0, 0.2);
  background-color: #fa821f;
  display: flex;
  font-size: 20px;
  justify-content: space-between;
  margin-bottom: 35px;
  padding-right: 6px;
  height: 60px;
  width: 90%;
  img {
    border: 5px solid #fa821f;
    border-radius: 50px;
    box-shadow: 0 2px 5px 2px rgba(0, 0, 0, 0.2);
    margin-top: 40px;
    margin-left: -35px;
    padding: 0;
  }
  input {
    border-radius: 5px;
    font-size: 35px;
    height: 35px;
    text-align: center;
    width: 80px;
    ::-webkit-input-placeholder {
      color: rgba(115, 115, 115, 0.5);
      font-weight: bolder;
    }
    :-moz-placeholder {
      color: rgba(115, 115, 115, 0.5);
      font-weight: bolder;
    }
    ::-moz-placeholder {
      color: rgba(115, 115, 115, 0.5);
      font-weight: bolder;
    }
    :-ms-input-placeholder {
      color: rgba(115, 115, 115, 0.5);
      font-weight: bolder;
    }
  }
`;

export const MiddleContent = styled.div`
  align-items: center;
  display: flex;
  font-size: 20px;
  justify-content: space-between;
  margin-bottom: 20px;
  padding: 10px;
  width: 100%;
  h3 {
    font-size: 15px;
    span {
      color: #2afaa5;
    }
  }
  p {
    align-items: center;
    background-color: #fff;
    border-radius: 50px;
    box-sizing: border-box;
    color: #2afaa5;
    display: flex;
    font-size: 30px;
    font-weight: bold;
    height: 45px;
    justify-content: center;
    padding-right: 30px;
    position: relative;
    width: 145px;
    span {
      font-size: 15px;
      margin: 10px 0 0 5px;
    }
    img {
      height: 45px;
      margin-right: -140px;
      position: absolute;
    }
  }
`;

export const Footer = styled.div`
  align-items: center;
  background-color: #fa821f;
  display: flex;
  font-size: 20px;
  justify-content: space-between;
  padding: 10px;
  width: 100%;
  h3 {
    font-size: 25px;
    span {
      font-size: 15px;
    }
  }
  p {
    align-items: center;
    background-color: #fff;
    border-radius: 50px;
    box-sizing: border-box;
    color: #2afaa5;
    display: flex;
    font-size: 30px;
    font-weight: bold;
    height: 45px;
    justify-content: center;
    padding-right: 30px;
    position: relative;
    width: 145px;
    img {
      height: 45px;
      margin-right: -140px;
      position: absolute;
    }
  }
`;

export const FirstRequestContainer = styled.div`
  align-items: center;
  background-color: #eb6d03;
  color: #fff;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  position: relative;
  width: 100%;
  div {
    align-items: center;
    display: flex;
    /* flex-direction: column; */
    justify-content: center;

    input {
    box-sizing: border-box;
    border-radius: 5px;
    height: 45px;
    padding: 5px;
    text-align: center;
    width: 90px;
    color: #737373;
    font-weight: bolder;
    font-size: 24px;
    ::-webkit-input-placeholder {
      color: #737373;
      font-weight: bolder;
      font-size: 24px;
    }
    :-moz-placeholder {
      color: #737373;
      font-weight: bolder;
      font-size: 24px;
    }
    ::-moz-placeholder {
      color: #737373;
      font-weight: bolder;
      font-size: 24px;
    }
    :-ms-input-placeholder {
      color: #737373;
      font-weight: bolder;
      font-size: 24px;
    }
  }
  }
  .buttons {
    flex-direction: row;
  }
  small {
    font-size: 10px;
  }
  
  p {
    align-items: center;
    background-color: #fff;
    border-radius: 25px;
    color: #2afaa5;
    display: flex;
    font-weight: bold;
    font-size: 20px;
    height: 45px;
    justify-content: space-between;
    margin-top: 15px;
    padding: 0 2px 0 15px;
    width: 150px;
    img {
      height: 42px;
      margin-top: 2px;
    }
    input {
    box-sizing: border-box;
    border-radius: 5px;
    height: 45px;
    padding: 5px;
    text-align: center;
    width: 80px;
    color: #2afaa5;
    font-weight: bolder;
    font-size: 20px;
    ::-webkit-input-placeholder {
      color: #2afaa5;
      font-weight: bolder;
      font-size: 20px;
    }
    :-moz-placeholder {
      color: #2afaa5;
      font-weight: bolder;
      font-size: 20px;
    }
    ::-moz-placeholder {
      color: #2afaa5;
      font-weight: bolder;
      font-size: 20px;
    }
    :-ms-input-placeholder {
      color: #2afaa5;
      font-weight: bolder;
      font-size: 20px;
    }
  }
  }
`;

export const ButtonRequest = styled.button`
  background-color: #00a000;
  box-shadow: 0 -2px 8px 1px rgba(0, 0, 0, 0.3);
  font-size: 22px;
  font-weight: bold;
  height: 60px;
  width: 100%;
  color: white
`;

export const ButtonContainer = styled.div`
  p {
    align-items: center;
    background-color: #fa821f;
    box-shadow: 0.5px 2px 4px rgba(0, 0, 0, 0.2);
    color: #fff;
    display: flex;
    font-size: 10px;
    height: 24px;
    justify-content: center;
    padding: 0;
    margin-bottom: 8px;
    margin-left: 5px;
    width: 50px;
  }
  button {
    border-radius: 50px;
    height: 30px;
    margin-bottom: 20px;
    width: 30px;
  }
  .checked {
    background-image: url("./images/checkin_on.svg");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 70%;
  }
`;


export const SecondRequestContainer = styled.div`
  background-color: #fa821f;
  color: #fff;
  display: flex;
  flex-direction: column;
  font-size: 25px;
  justify-content: space-around;
  position: relative;
  padding: 25px 25px 0;
  width: 100%;
  h3 {
    font-weight: bolder;
  }
  p {
    align-items: center;
    background-color: #fff;
    border-radius: 25px;
    color: #2afaa5;
    display: flex;
    font-weight: bolder;
    height: 40px;
    justify-content: space-between;
    margin-bottom: 25px;
    padding-left: 5px;
    img {
      width: 38px;
    }
  }
`;

export const TotalsContainer = styled.div`
  align-items: flex-end;
  background-color: #fa821f;
  border-radius: 50px;
  display: flex;
  height: 90px;
  justify-content: space-around;
  margin: 5px auto;
  padding-bottom: 5px;
  padding-right: 5px;
  width: 95%;
  p {
    align-items: center;
    background-color: #fff;
    border-radius: 25px;
    color: #2afaa5;
    display: flex;
    font-weight: bold;
    font-size: 30px;
    height: 44px;
    justify-content: flex-start;
    margin-bottom: 5px;
    padding-left: 15px;
    position: relative;
    text-align: center;
    width: 240px;
    img {
      height: 44px;
      margin-left: 61px;
      position: absolute;
    }
  }
  img {
    margin-left: -2px;
    height: 80px;
  }
  div {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    font-size: 20px;
    height: 100%;
    justify-content: space-between;
    padding-top: 5px;
  }
`;
export const TotalsDifferent = styled(TotalsContainer)`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-left: 100px;

  img {
    position: absolute;
    margin-left: -96px;
    margin-top: 5px;
  }
  h4 {
    font-weight: bold;
    font-size: 20px;
    margin-top: 5px;
  }
  p {
    align-items: center;
    display: flex;
    /* justify-content: star; */
    padding-left: 15px;
    width: 96%;
    img {
      height: 100%;
      margin-bottom: 5px;
      margin-left: 76%;
      position: absolute;
    }
  }
`;
